export const PROVIDER_LABEL = { WABA_CLOUD: "WABA", IVOSIGHTS: "ivowaba" };

// Rate in force for a provider on a 'YYYY-MM-DD' date: latest effectiveFrom
// not after it. Mirrors the backend's lookup.
export const rateOn = (rates, provider, date) =>
  rates
    .filter((r) => r.provider === provider && r.effectiveFrom <= date)
    .sort((a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1))[0];

export const sortRows = (rows, key, dir) =>
  [...rows].sort((a, b) => {
    const x = a[key];
    const y = b[key];
    const cmp = typeof x === "number" ? x - y : String(x).localeCompare(String(y));
    return dir === "asc" ? cmp : -cmp;
  });
